export default __webpack_public_path__ + "static/media/Sofia-bold.ff83ebbc.ttf";